import { useCallback, useEffect, useState } from "react";
import { apiLaunchPad } from "../../../api/apiLaunchPad";
import { Spin, Pagination } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import ProjectCard from "../card/ProjectCard";
import LaunchpadEmtyCard from "../card/LaunchpadEmtyCard";
import { CampaignType } from "../../../type";

const Upcoming = () => {
  const [loading, setLoading] = useState(false);
  const [dataListPool, setDataListPool] = useState<CampaignType[]>([]);
  const [keySearch, setKeySearch] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [param, setParam] = useState({ page: 1, limit: 6 });
  // const navigate = useNavigate();

  const useDebounce = (value: string, delay: number) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      return () => clearTimeout(handler);
    }, [value, delay]);
    return debouncedValue;
  };

  const debouncedKeySearch = useDebounce(keySearch, 1000);

  const GetListPoolUpcoming = useCallback(async () => {
    setLoading(true);
    try {
      let res = await apiLaunchPad.getPoolUpcoming(
        param?.page,
        param?.limit,
        keySearch
      );
      if (res.data.code === 200) {
        setDataListPool(res.data.data);
        setTotalCount(res.data.total);
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      setLoading(false);
    }
  }, [keySearch, param?.limit, param?.page]);

  useEffect(() => {
    GetListPoolUpcoming();
  }, [GetListPoolUpcoming, debouncedKeySearch, param]);

  const onChange_Pagi = (pageNumber: any) => {
    setParam({
      ...param,
      page: pageNumber,
    });
  };

  const handleSearch = (e: any) => {
    setKeySearch(e.target.value);
    setParam({
      ...param,
      page: 1,
    });
  };

  return (
    <div className="main-page-opening">
      <div className="container">
        <div className="wrap-opening">
          <div className="main-title main-title-desk">
            <img src="./images/title-up.png" alt="" />
          </div>
          <div className="main-title main-title-mo">
            <img src="./images/title-up-mo.svg" alt="" />
          </div>
          <div className="filter-page">
            <div className="search-input">
              <input
                type="text"
                onChange={handleSearch}
                placeholder="Search by project name, token symbol"
                className="f-search"
              />
              <div className="icon">
                <img src="./images/icon-search.png" alt="" />
              </div>
            </div>
          </div>
          <div className="wrap-item-opening">
            {loading ? (
              <div className="spin-loading">
                <Spin
                  className="w-100"
                  size="large"
                  indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />}
                />
              </div>
            ) : dataListPool.length === 0 ? (
              <>
                {!keySearch === true ? (
                  <>
                    <div className="columns">
                      <LaunchpadEmtyCard />
                      <div className="colum w-4">
                        <img
                          style={{ width: "100%", height: "100%" }}
                          src="./images/empty-project2.png"
                          alt=""
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="colum w-4 nodata-new">
                      <div className="line-top2">
                        <img src="./images/line-top.png" alt="" />
                      </div>
                      <img className="img33" src="./images/nodata.png" alt="" />
                      <div className="line-bot2">
                        <img src="./images/line-bot.png" alt="" />
                      </div>
                    </div>
                  </>
                )}
              </>
            ) : (
              <div className="mt-6 flex flex-wrap">
                {dataListPool.map((project) => (
                  <div className="w-full sm:w-1/2 lg:w-1/3">
                    <ProjectCard key={project.id} cardData={project} />
                  </div>
                ))}
              </div>
            )}
            <br />
            {Number(totalCount) > Number(param?.limit) && (
              <Pagination
                current={param.page}
                defaultCurrent={1}
                total={totalCount}
                pageSize={param.limit}
                onChange={onChange_Pagi}
                showSizeChanger={false}
                style={{ marginTop: "15px" }}
                className="pagiation-custom mt-15"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Upcoming;
